import { createContext, useContext } from 'react';

export const PRE_AUTH_CONFIG_CONTEXT = createContext();

export const usePreAuthConfig = () => useContext(PRE_AUTH_CONFIG_CONTEXT);
